import { useEffect, useState } from "react";
import { encodeCuijPath } from "@tribunalea/shared";
import { AppLink, PageHeader, useRouter } from "@tribunalea/ui";
import { useApi } from "../App.jsx";

export function ExternalExpedienteRedirectPage({ externalId }) {
  const api = useApi();
  const { navigate } = useRouter();
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    api.resolveExpedienteExternalId(externalId)
      .then(({ cuij }) => {
        if (!controller.signal.aborted) {
          navigate(`/expedientes/${encodeCuijPath(cuij)}`, { replace: true });
        }
      })
      .catch((requestError) => {
        if (!controller.signal.aborted) {
          setError(
            requestError.message
            || "No pudimos relacionar el documento de IOL con un expediente.",
          );
        }
      });
    return () => controller.abort();
  }, [api, externalId, navigate]);

  return (
    <main className="page">
      <PageHeader
        eyebrow="Praxis"
        title="Abriendo expediente"
        description={error || "Relacionando el documento de IOL con Tribunalea…"}
      />
      {error && <AppLink to="/expedientes">Ir a Mis expedientes</AppLink>}
    </main>
  );
}
